module.exports = __webpack_public_path__ + "img/framework2_Image.418f1253.png";